import { Component } from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '../../../../Services/BuissnessLogic/auth.service';
import {ColorScssService} from '../../../../shared/service/color-scss.service';
import {CheckoutHelperService} from '../../../../Services/BuissnessLogic/Checkout/checkout-helper.service';

@Component({
  selector: 'app-thank-you-for-order-bank',
  standalone: true,
  imports: [],
  templateUrl: './thank-you-for-order-bank.component.html',
  styleUrl: './thank-you-for-order-bank.component.scss'
})
export class ThankYouForOrderBankComponent {
  email: string = ""
  constructor(private router: Router,
              private auth: AuthService,
              private color: ColorScssService,
              private checkoutHelper: CheckoutHelperService,
  ) {
    color.resetColorScheme()
    this.email = this.checkoutHelper.currentOrder.customer.email
  }
  onCreateAccount() {
    this.router.navigate(['/registrieren']);
  }
}
